import React from 'react';

const FacebookLogo = ({
  width = 50,
  height = 50,
  color = '#066653',
  ...props
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 50 50'
    fill={color}
    aria-label='Facebook logo'
    {...props}>
    <path d='M25 3C12.85 3 3 12.85 3 25c0 11.03 8.12 20.14 18.71 21.728V30.831h-5.443v-5.783h5.443v-3.848c0-6.37 3.1-9.17 8.4-9.17 2.54 0 3.88.188 4.51.274v5.048h-3.612c-2.25 0-3.03 2.13-3.03 4.533v3.161h6.588l-.894 5.783h-5.694v15.944C38.716 45.32 47 36.14 47 25 47 12.85 37.15 3 25 3z' />
  </svg>
);

export default FacebookLogo;
